import _ from "lodash";
import moment from "moment";

export const formatGain = gain => {
  return `${Number((gain * 100 || 0).toFixed(2))}%`;
}

export const formatHours = (minutes = 0) => {
  let d = moment.duration(minutes, 'minutes');
  let h = _.toInteger(d.as('hours'));
  let m = d.minutes();
  return `${h}h ${m}m`;
}

export const formatMinutes = time => {
  let d = moment.duration(time, 'minutes');
  return formatNumber(d.as('minutes')) + ' min';
}

export const formatSeconds = time => {
  let d = moment.duration(time);
  let s = d.as('seconds');
  return formatNumber(s) + 's';
}

export const formatPercent = (p, d = 2) => {
  p = _.round((p || 0) * 100, d);
  return `${p}%`;
}


export const formatNumber = (num, dec, fallback = 0) => {
  let options = {
    minimumFractionDigits: dec ?? 0,
    maximumFractionDigits: dec ?? 0,
  }
  let fm = new Intl.NumberFormat(navigator.language, options);
  return fm.format(num ?? fallback);
}

export const formatMoney = (num, dec, fallback = 0) => {
  let options = {
    minimumFractionDigits: dec ?? num < 1 ? 2 : 0,
    maximumFractionDigits: dec ?? num < 1 ? 2 : 0,
  }
  let fm = new Intl.NumberFormat(navigator.language, options);
  return fm.format(num ?? fallback);
}

export const milisecondsToMinutes = ms => {
  let d = moment.duration(ms);
  let min = d.as('minutes')
  return `${formatNumber(min)} ${pluralize('min', min)}`;
}


export const shortString = (str = '', length = 5) => {
  return `${str.slice(0,length)}...${str.slice(-length)}`;
}

export const clipString = (str = '', length = 5) => {
  if(str.length <= length )
    return str;

  return `${str.slice(0,length)}...`;
}

export const storageAvailable = (type = 'localStorage') => {
  var storage;
  try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
  }
  catch(e) {
      return e instanceof DOMException && (
          // everything except Firefox
          e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          (storage && storage.length !== 0);
  }
}

export const pluralize = (string, count) => (count > 1 || count === 0) ? string+'s' : string;

export const randomId = () => Math.random().toString().substr(2, 8); 

export function move(array, iteratee, toIndex) {
  const item = _.find(array, iteratee);
  if(!item)
    return array;
    
  const moveIndex = _.findIndex(array, iteratee);
  const length = array.length;
  const diff = moveIndex - toIndex;

  if(diff > 0) {
    // move left
    return [
      ...array.slice(0, toIndex),
      item,
      ...array.slice(toIndex, moveIndex),
      ...array.slice(moveIndex + 1, length)
    ];
  } else if(diff < 0) {
    // move right
    const targetIndex = toIndex + 1;
    return [
      ...array.slice(0, moveIndex),
      ...array.slice(moveIndex + 1, targetIndex),
      item,
      ...array.slice(targetIndex, length)
    ];
  }
  return array;
}

// Executes a function after an async function, but no earlier than time period
export const waitAtLeast = async (execFun, afterFun, timerRef, atLeast = 500) => {
  let execComplete = false;
  let timerComplete = false;
    
  timerRef.current = setTimeout(() => afterFun(), atLeast);

  await execFun();
  execComplete = true;
  if(timerComplete)
    afterFun();
}